module.exports = __webpack_public_path__ + "static/media/askQuestion.ef4d2ebd.png";